import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { Link } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  footer: {
    paddingTop: 30,
    paddingBottom: 20,
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]:{
      paddingLeft: 10,
      paddingRight: 10,
    }
  },
  image: {
      height: 50,
      [theme.breakpoints.down('sm')]:{
          height: 35
      }
  }
}));

export default function Footer() {
  const classes = useStyles();
  const year = (new Date()).getFullYear();
  return (
    <footer className={classes.footer}>
      <Box flexGrow={1}>
        <img src={`${process.env.PUBLIC_URL}/images/nexspec-logo-white.svg`} alt="Nexspec logo" className={classes.image} />
        <Typography variant="body2">11111 Santa Monica Blvd Suite 900</Typography>
        <Typography variant="body2">Los Angeles, CA 90025</Typography>
        <Typography variant="body2">info@nexspec.com</Typography>
        <Link href="/privacy" color='inherit'><Typography variant="body2">Privacy Policy</Typography></Link>
      </Box>
      <Box position='relative' width={200} textAlign='right'>
          <Box textAlign='right' position='absolute' bottom={0} right={0}>
            {/* <Typography variant="body2">{`Something else here`}</Typography> */}
            <Typography variant="body2">{`© NexSpec ${year}`}</Typography>
          </Box>
      </Box>
    </footer >
  );
}
